<template>
  <b-row>
    <b-col cols="12">
      <manufacturing-orders-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ManufacturingOrdersTable from './ManufacturingOrdersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    ManufacturingOrdersTable,

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
